// src/pages/PostAd.js
import React, { useState } from 'react';
import { usePostAd } from '../../contexts/PostAdContext';
import CategoryPicker from '../../components/PostAd/CategoryPicker';
import AIUploader from '../../components/PostAd/AIUploader';
import DynamicForm from '../../components/PostAd/DynamicAdForm';
import LocationPicker from '../../components/PostAd/LocationPicker';
import './PostAd.css';
import ReviewAd from '../../components/PostAd/ReviewAd';
import { QoboWidget, QoboState } from '../../widgets/QoboWidget';
import manualPostAnimation from "../../assets/animation/manual_post_animation.json";
import Lottie from 'lottie-react';


const PostAd = () => {
    const context = usePostAd();
    if (!context) return <div className="p-20">Loading Post Ad Flow...</div>;

    console.log("PostAd Component: Rendering with step", context?.step);

    const { step, setStep, flowType, setFlowType, resetFlow } = context;

    const handleChoice = (type) => {
        console.log("Choice Clicked:", type);
        setFlowType(type);
        setStep(type === 'AI' ? 2 : 1.5); // 1.5 is Category selection for manual
    };

    return (
        <div className="post-ad-page">
            <div className="post-ad-container">

                {/* Step 1: The Initial Choice */}
                {step === 1 && (
                    <div className="choice-container">
                        <h1>How would you like to list?</h1>
                        <div className="choice-cards">
                            <div className="choice-card magic" onClick={() => handleChoice('AI')}>
                                <div className="magic-icon"><QoboWidget state={QoboState.IDLE} size={150} /></div>
                                <h2>Qobo Magic</h2>
                                <p>Upload a photo and our AI will draft the entire ad for you.</p>
                                <span className="badge">Recommended</span>
                            </div>
                            <div className="choice-card manual" onClick={() => handleChoice('MANUAL')}>
                                <div className="manual-icon">
                                    <Lottie
                                        animationData={manualPostAnimation}
                                        loop={true}
                                        autoplay={true}
                                        style={{height: "150px"}}
                                    />
                                </div>
                                <h2>Manual Post</h2>
                                <p>Select a category and fill in the details yourself.</p>
                            </div>
                        </div>
                    </div>
                )}

                {/* Step 1.5: Manual Category Selection */}
                {step === 1.5 && <CategoryPicker />}

                {/* Step 2: AI Uploader / Image Analysis */}
                {step === 2 && <AIUploader />}

                {/* Step 3: The Form (AI-Refinement or Manual Entry) */}
                {step === 3 && <DynamicForm />}

                {/* Step 4: Precise Location */}
                {step === 4 && <LocationPicker />}

                {/* {step > 1 && (
                    <button className="reset-btn" onClick={resetFlow}>Cancel & Start Over</button>
                )} */}
                {step === 5 && <ReviewAd />}
            </div>
        </div>
    );
};

export default PostAd;